var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-select',_vm._g(_vm._b({attrs:{"items":_vm.listItems,"item-text":"name","item-value":"_id","value":_vm.value,"rules":_vm.rules,"label":"Select Organisation"},on:{"input":function($event){return _vm.updateValue($event)}}},'app-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }